import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import SearchBar from "../components/SearchBar/SearchBar";
import Table from "../components/Table/Table";
import TopNavbar from "../components/TopNavbar/TopNavbar";
import ApiManager from "../ApiManager/ApiManager";
import { useNavigate } from "react-router-dom";
import Modal from "../components/Modal/Modal";
import ViewEntity from "../components/ViewEntity/ViewEntity";
import EditDriver from "../components/DriverComponents/Editdriver";
import { useAuth } from "../components/AuthProvider";
import { hasPermission, ShowButton } from "../components/RoleBasedComponents";
import PERMISSIONS from "../permissions";
import { useComponentLoading } from "../utils/useComponentLoading";
import { ToastContainer, toast } from "react-toastify";

function Drivers() {
  const { userPermissions } = useAuth();
  const { withLoading, isLoading, getMessage, getProgress } = useComponentLoading();
  const location = useLocation();

  const [data, setData] = useState([]);
  const [rowId, setRowId] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isDetails, setDetails] = useState(true);
  const [isEdit, setEdit] = useState(false);
  const [isChangePassword, setChangePassword] = useState(false);
  const [password, setPassword] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMorePages, setHasMorePages] = useState(true);

  useEffect(() => {
    fetchData();
  }, [currentPage]);

  useEffect(() => {
    if (location.state?.toast) {
      const { type, message } = location.state.toast;
      if (type === 'success') {
        toast.success(message);
      } else if (type === 'error') {
        toast.error(message);
      }
      // Clear the state to prevent showing the toast again on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  const fetchData = async () => {
    try {
      await withLoading('fetchDrivers', async (onProgress) => {
        onProgress(20, 'Fetching drivers...');
        const params = new URLSearchParams({
          page_size: 12,
          page: currentPage,
        });
        const response = await ApiManager.getAllDrivers(params);
        onProgress(60, 'Processing data...');
        if (!response.ok) throw new Error("Failed to fetch drivers");
        const json = await response.json();
        setData(json);
        setHasMorePages(json.length == 12);
        onProgress(100, 'Completed');
      });
    } catch (error) {
      console.error("Error fetching drivers:", error);
      setHasMorePages(false);
    }
  };

  const navigate = useNavigate();

  const handleClick = (path) => {
    navigate(path);
  };

  const updatePassword = async () => {
    try {
      const query = new URLSearchParams({
        driverId: rowId,
      });
      const response = await ApiManager.updateDriverPassword(query, {
        password,
      });
      if (!response.ok) throw new Error("Network response was not ok");
      const json = await response.json();
    } catch (error) {
      console.log("Error fetching data:", error);
    }
    toggleModal();
  };

  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setPassword(value);
  };

  const handleEdit = () => {
    navigate(`/login/drivers/edit_driver/${rowId}`);
  };

  const handleDetails = () => {
    console.log("Details clicked for row:");
    setDetails(true);
    setEdit(false);
    setModalOpen(true);
    setChangePassword(false);
  };

  const handleChangePassword = () => {
    setChangePassword(true);
    setDetails(false);
    setEdit(false);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleDriverPayroll = (path, rowId) => {
    navigate(`${path}/${rowId}`);
  };

  const buttons = [{ label: "Details", onClick: () => handleDetails() }];

  if (hasPermission(userPermissions, PERMISSIONS.VENDOR_DRIVER_UPDATE)) {
    buttons.push({ label: "Edit", onClick: () => handleEdit() });
    buttons.push({
      label: "Change Password",
      onClick: () => handleChangePassword(),
    });
  }

  if (
    hasPermission(userPermissions, PERMISSIONS.VENDOR_ATTENDANCE_DRIVER_READ)
  ) {
    buttons.push({
      label: "Attendence",
      onClick: () => handleDriverPayroll("attendance", rowId),
    });
  }

  if (hasPermission(userPermissions, PERMISSIONS.VENDOR_PAYROLL_READ)) {
    buttons.push({
      label: "Payroll",
      onClick: () => handleDriverPayroll("driver_payroll", rowId),
    });
  }

  const columns = [
    { field: "firstName", headerName: "First Name" },
    { field: "lastName", headerName: "Last Name" },
    { field: "licenseNo", headerName: "License Number" },
    { field: "phone", headerName: "Phone Number" },
  ];

  const rows = (data || []).map((item) => ({
    firstName: item.firstName,
    lastName: item.lastName,
    id: item.id,
    licenseNo: item.licenseNo,
    phone: item.phone,
  }));

  

  return (
    <div>
      <ToastContainer />
        <div>
          <TopNavbar
            title="Drivers"
          />
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              width: "100%",
              paddingTop: "20px",
              height: "5vh",
            }}
          >
            {/* <SearchBar /> */}
            <ShowButton permission={PERMISSIONS.VENDOR_DRIVER_CREATE}>
             
                <button
                  className="custom-button"
                  onClick={() => handleClick("/login/new_driver")}
                >
                  New Driver
                </button>
              
            </ShowButton>
          </div>
          <Table
            table_columns={columns}
            rows={rows}
            setRowsId={setRowId}
            buttons={buttons}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            hasMorePages={hasMorePages}
            isLoading={isLoading('fetchDrivers')}
            loadingMessage={getMessage('fetchDrivers')}
            loadingProgress={getProgress('fetchDrivers')}
          />
          {isModalOpen && isDetails && (
            <div className="details-container">
              <Modal isOpen={true} onClose={handleModalClose}>
                <ViewEntity
                  id={rowId}
                  fetchFunction={ApiManager.getDriver}
                  columns={columns}
                  entity="driverId"
                />
              </Modal>
            </div>
          )}
          {isModalOpen && isChangePassword && (
              <Modal isOpen={true} onClose={handleModalClose} title="Change Password">
                <div style={{ display: "flex", flexDirection: "column", gap: "20px" ,width:"100%"}}>
                  <form style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <label>Old Password: </label>
                    <input type="text" onChange={handleChange} style={{padding:"10px",borderRadius:"5px",border:"1px solid #ccc"}} />
                  </form>
                  <form style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <label>New Password: </label>
                    <input type="text" onChange={handleChange} style={{padding:"10px",borderRadius:"5px",border:"1px solid #ccc"}} />
                  </form>
                  <button type="submit" onClick={() => updatePassword()}>Submit</button>
                </div>
              </Modal>
          )}
        </div>
    </div>
  );
}

export default Drivers;
